import { Rate } from "antd";
import { useRouter } from "next/router";

import { ButtonComponent } from "../../../helper/ReusableComponents";
import featuredActsStyles from "../../TalentComponent/FeaturedActsComponent/FeaturedActsComponent.module.css";
import styles from "./CityBandPerformedComponent.module.css";

export default function CityBandPerformedComponent(props) {
  const { data } = props;
  const router = useRouter();

  const onExploreBtnClick = (item) => {
    router.push(`/band/${item.slug}`);
  };

  return (
    data &&
    data.length > 0 &&
    data[0].hasOwnProperty("name") &&
    data[0].hasOwnProperty("reviewRatings") &&
    data[0].photo !== null ? (
      <section id="bandPerformed" className={styles.band_performed_container}>
      <div className={styles.band_performed_overlay_bg}></div>
      <h1 className={styles.city_band_performed_heading}>
       {  
        props.venueURL ? 
          <>Our Bands that have Performed in <a className="venue-name" href={props.venueURL} target="_blank" rel="noreferrer">{props.name}</a></> : 
          <>Our Bands that have Performed in {props.name}</> 
        }
      </h1>
        <div
          className={styles.bandPerformed_card}
          style={{ marginLeft: "64px" }}
        >
          <ul
            className={`d-flex align-items-center flex-wrap ${featuredActsStyles.featured_act_cards}`}
            style={{ marginTop: "64px" }}
          >
            {data.map((item, index) => (
              <li
                className={` ml-5 ${featuredActsStyles.featured_act_card}`}
                key={index}
              >
                <figure className={featuredActsStyles.featured_act_card_figure}>
                  <img
                    src={
                      item?.photo !== ""
                        ? process.env.IMAGE_LINK + item?.photo
                        : "/assets/images/video_slide_two.png"
                    }
                    alt={`${item?.name}`}
                    width={240}
                    height={352}
                    onClick={() => onExploreBtnClick(item)}
                  />
                </figure>
                <div className={featuredActsStyles.featured_act_card_body}>
                  <h5 className={featuredActsStyles.featured_act_card_heading}>
                    {item?.name}
                  </h5>
                  <div className={`d-flex justify-content-between flex-wrap `}>
                    <div
                      className={`d-flex align-items-center ${featuredActsStyles.featured_act_card_rating}`}
                    >
                      {item?.numberOfReviews > 0 &&
                      <Rate
                        allowHalf
                        value={
                          item
                            ? item.reviewRatings
                              ? item.reviewRatings
                              : 0
                            : 0
                        }
                        disabled
                        className={
                          featuredActsStyles.featured_act_card_rating_star
                        }
                      />}
                      {item?.numberOfReviews > 0 &&
                      <p
                        className={
                          featuredActsStyles.featured_act_card_rating_reviews
                        }
                      >
                        {item?.numberOfReviews} reviews
                      </p>}
                    </div>
                    <div className={styles.explore_btn_height_bottom}>
                    <button
                      className={`${featuredActsStyles.featured_act_card_explore_btn} mb-auto`}
                      onClick={() => onExploreBtnClick(item)}
                    >
                      Explore
                    </button>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      <div className="d-flex justify-content-center">
        <ButtonComponent
          data={{
            type: "button",
            className: styles.city_band_btn,
            onClick: () => router.push("/our-talent"),
          }}
        >
          See More Wedding Bands
        </ButtonComponent>
      </div>
    </section>
    ) : null
  )
}
